import { HubTable } from "@/ds";
import type { HubTableProps } from "@/ds";
import { hubTableCartao } from "./hub-table-cartao.constants";

export type HubTableCartaoProps<T, C extends string, F extends string> = Omit<
  HubTableProps<T, C, F>,
  "loadingView" | "emptyView" | "dataKey" | "classNames" | "paginatorProps"
> & {
  /** Nome acessível do seletor de linhas por página (ex.: "Embarcações por página"). */
  readonly rowsPerPageLabel: string;
};

/**
 * Invólucro das listagens completas em cartão (Obras, Financeiro, Embarcações): `HubTable` com carregamento em overlay,
 * vazio que ocupa o cartão, linhas por `id` e as classes do cartão, do corpo que rola e do paginador. O que muda de tela
 * para tela (colunas, estados, rótulos) vem pelas props e pelos filhos.
 */
export function HubTableCartao<T, C extends string, F extends string>({
  rowsPerPageLabel,
  className,
  dataTableProps,
  children,
  ...rest
}: HubTableCartaoProps<T, C, F>) {
  return (
    <HubTable.Root<T, C, F>
      {...rest}
      loadingView="overlay"
      emptyView="replace"
      dataKey="id"
      dataTableProps={{
        ...dataTableProps,
        className: hubTableCartao.dataTableClassName,
        pt: hubTableCartao.dataTablePt,
      }}
      paginatorProps={{ pt: { RPPDropdown: { input: { "aria-label": rowsPerPageLabel } } } }}
      className={className ? `${hubTableCartao.className} ${className}` : hubTableCartao.className}
      classNames={hubTableCartao.classNames}
    >
      {children}
    </HubTable.Root>
  );
}
